
export const routeExtra = {
  'steepness': 'steepness',
  'routesize': 'routesize',
  'routefoot': 'routefoot',
};

export const colorMappings = {
  [routeExtra.steepness]: {
    '0': {
      text: '0',
      color: '#e6e699',
    },
    '1': {
      text: '1',
      color: '#f1c040',
    },
    '2': {
      text: '2',
      color: '#ef8b28',
    },
    '3': {
      text: '3',
      color: '#e6361e',
    },
    '4': {
      text: '4',
      color: '#994720',
    },
  },
  [routeExtra.routesize]: {
    "1": {
      text: "SINGLE_TRACK_TRAIL",
      color: "#591300",
      order: 3,
    },
    "2": {
      text: "PATH_BIGGER_THAN_FIFTY_CM",
      color: "#861D00",
      order: 2,
    },
    "3": {
      text: "WIDE_PATH",
      color: "#FF6238",
      order: 1,
    },
    "4": {
      text: "VERY_WIDE_PATH",
      color: "#FF977A",
      order: 0,
    },
    "0": {
      text: "UNDEFINED",
      color: "#C0C0C0",
      order: 99,
    },
  },
  [routeExtra.routefoot]: {
    "1": {
      "text": "IRREGULAR",
      "color": "#DA74CE",
      order: 2,
    },
    "2": {
      "text": "REGULAR",
      "color": "#E59EDD",
      order: 1,
    },
    "3": {
      "text": "TECHNICAL_SECTION",
      "color": "#87387E",
      order: 3,
    },
    "4": {
      "text": "HIGHLY_TECHNICAL_SECTION",
      "color": "#50164A",
      order: 4,
    },
    "5": {
      "text": "REGULAR_LIGHT_SLOPES",
      "color": "#F2CFEE",
      order: 0,
    },
    "0": {
      "text": "UNDEFINED",
      "color": "#C0C0C0",
      order: 99,
    },
  },
};

export function shouldShowSportsDropdown (iframeMode, value) {
  return !iframeMode || !(value?.length);
}
